import type { ReactNode } from "react";
import { Link } from "wouter";
import { LocationPin } from "./LocationPin";
import "./SidebarIdentityCard.css";

export function SidebarIdentityCard({ cover, avatar, name, badge, subtitle, city, footer, href }: {
  cover?: ReactNode; avatar: ReactNode; name: string; badge?: ReactNode;
  subtitle?: string; city?: string; footer?: ReactNode; href?: string;
}) {
  const identity = <><div className="sidebar-identity-avatar">{avatar}</div><div className="sidebar-identity-name"><strong>{name}</strong>{badge}</div>{subtitle && <p className="sidebar-identity-subtitle">{subtitle}</p>}{city && <div className="sidebar-identity-location"><LocationPin /><span>{city}</span></div>}</>;
  return <section className="sidebar-identity-card"><div className="sidebar-identity-cover">{cover}</div><div className="sidebar-identity-body">{href ? <Link className="sidebar-identity-open" href={href}>{identity}</Link> : identity}{footer && <div className="sidebar-identity-footer">{footer}</div>}</div></section>;
}
